// Button loading states and retain information for input fields
const accountErrorMessage = document.querySelector(
    '.account-form-error-message'
  );
  
  const handleAccountLoadingState = (buttonElement) => {
    buttonElement.setAttribute('aria-disabled', true);
    buttonElement.querySelector('.account-text').remove();
    buttonElement.querySelector('.hide').classList.remove('hide');
  };
  
  window.addEventListener('DOMContentLoaded', () => {
  customerAddressForm();
  });
  
  /**
  *
  *  Show/hide customer address forms
  *
  */
  function customerAddressForm() {
  var newAddressForm = document.getElementById('AddressNewForm');
  var newAddressFormButton = document.getElementById('AddressNewButton');
  
  if (!newAddressForm) {
    return;
  }
  
  // Initialize each edit form's country/province selector
  document
    .querySelectorAll('.address-country-option')
    .forEach(function (option) {
      var formId = option.dataset.formId;
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;
  
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector,
      });
    });
  
  // Toggle new/edit address forms
  document.querySelectorAll('.address-new-toggle').forEach(function (button) {
    button.addEventListener('click', function () {
      var isExpanded =
        newAddressFormButton.getAttribute('aria-expanded') === 'true';
  
      newAddressForm.classList.toggle('hide');
      newAddressFormButton.setAttribute('aria-expanded', !isExpanded);
      newAddressFormButton.focus();
    });
  });
  
  document
    .querySelectorAll('.address-edit-toggle')
    .forEach(function (button) {
      button.addEventListener('click', function (evt) {
        var formId = evt.currentTarget.dataset.formId;
        var editButton = document.getElementById('EditFormButton_' + formId);
        var editAddress = document.getElementById('EditAddress_' + formId);
        var isExpanded = editButton.getAttribute('aria-expanded') === 'true';
  
        editAddress.classList.toggle('hide');
        editButton.setAttribute('aria-expanded', !isExpanded);
        editButton.focus();
      });
    });
  
  document.querySelectorAll('.address-delete').forEach(function (button) {
    button.addEventListener('click', function (evt) {
      var target = evt.target.dataset.target;
      var confirmMessage = evt.target.dataset.confirmMessage;
  
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink(target, {
          parameters: { _method: 'delete' },
        });
      }
    });
  });
  }